/*!
=========================================================
* Muse Ant Design Dashboard PRO - v1.1.0
=========================================================
* Product Page: https://www.creative-tim.com/product/muse-ant-design-dashboard-pro
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Coded by Creative Tim
=========================================================
* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import "antd/dist/antd.min.css";
import "antd-button-color/dist/css/style.css";
import "./App.css";
import "./responsive.css";
import { BrowserRouter, Switch, Route, Redirect, useLocation } from "react-router-dom";
import React, { useEffect, useState, useContext } from "react";
import { ThemeProvider } from "./context/ThemeContext";

import SignUp from "./component/pages/SignUp";

import Main from "./component/layout/main";
import Pricing from "./component/pages/Pricing";
import Cover from "./component/authentication/signup/Cover";
import Illustration from "./component/authentication/signup/Illustration";
import PageFound from "./component/pages/PageFound";
import SignupPage from "./component/authentication/signup/SignUp";
import LoginPage from "./component/authentication/login/Login";
import ResetPasswordPage from "./component/authentication/resetPassword/ResetPassword";
import ForgotPasswordPage from "./component/authentication/forgetPassword/forgetPassword";
import HomePage from "./component/pages/home/HomePage";
import PricingPage from "./component/pages/pricing_page/PricingPage";
import SupportPage from "./component/pages/support_page/SupportPage";
import PublicVideoPage from "./component/pages/patient_public/PatientVideo";
import JourneyPreviewPage from "./component/pages/journeys/JourneyPreviewPage";
import { isLogin } from "./utils/localStorage";
import { SpecilityContext } from "./context/SpecilityContext";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

// Fix ConditionalReCaptchaProvider to use correct key logic
const ConditionalReCaptchaProvider = ({ children }) => {
  const location = useLocation();
  // Define authentication routes that need reCAPTCHA
  const authRoutes = ['/sign-up', '/login', '/reset-password', '/forget-password'];
  const isAuthRoute = authRoutes.some(route => location.pathname.startsWith(route));
  const recaptchaKey = window.location.hostname === 'localhost'
    ? '6Lc3t34rAAAAAKznWNmdy6M_o8lg-7dYwAREQajs'
    : '6Lfac38rAAAAABfShY5ktvwwCvzUT7S244P1v8CP';
  if (isAuthRoute) {
    return (
      <GoogleReCaptchaProvider reCaptchaKey={recaptchaKey}>
        {children}
      </GoogleReCaptchaProvider>
    );
  }
  return children;
};

// Component to handle HubSpot script loading based on location
const HubSpotLoader = () => {
  const location = useLocation();

  function loadHubspotScript() {
    const script = document.createElement("script");
    script.src = "//js.hs-scripts.com/242766010.js";
    script.type = "text/javascript";
    script.async = true;
    script.defer = true;
    script.id = "hs-script-loader";
    document.body.appendChild(script);
  }

  useEffect(() => {
    const publicRoutes = [
      '/',
      '/sign-up',
      '/login',
      '/reset-password',
      '/forget-password',
      '/pricing',
      '/support',
      '/pages/pricing'
    ];
    
    const currentPath = location.pathname;
    const isPublicPage = publicRoutes.some(route => route === currentPath );
    
    // Load HubSpot script only on public pages and if not already loaded
    if (isPublicPage && !document.getElementById('hs-script-loader')) {
      loadHubspotScript();
    }
  }, [location.pathname]);

  return null;
};

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(isLogin());

  return (
    <ThemeProvider>
      <div className="App">
        <BrowserRouter>
          <HubSpotLoader />
          <ConditionalReCaptchaProvider>
            <Switch>
              <Route path="/" exact component={HomePage} />
              <Route path="/sign-up" exact component={SignupPage} />
              <Route path="/login" exact component={LoginPage} />
              <Route
                path="/reset-password/:token"
                exact
                component={ResetPasswordPage}
              />
              <Route
                path="/forget-password"
                exact
                component={ForgotPasswordPage}
              />
              <Route path="/pricing" exact component={PricingPage} />
              <Route path="/support" exact component={SupportPage} />
              <Route
                path={"/public/video/:videoToken"}
                exact
                component={PublicVideoPage}
              />
              <Route
                path={"/journey/:id"}
                exact
                component={JourneyPreviewPage}
              />
              {/* <Route path="/sign-up" exact component={SignUp} /> */}
              <Route
                path="/authentication/sign-up/basic"
                exact
                component={SignUp}
              />
              <Route
                path="/authentication/sign-up/cover"
                exact
                component={Cover}
              />
              <Route
                path="/authentication/sign-up/illustration"
                exact
                component={Illustration}
              />
              <Route path="/sign-in" exact component={PageFound} />
              {/* <Route path="/sign-in" exact component={SignIn} /> */}
              <Route path="/pages/pricing" exact component={Pricing} />
              <Route path="/:id" component={Main} />
              <Route path="*" component={PageFound} />
              {/* <Redirect
                  to={{
                    pathname: "/dashboard",
                  }}
                /> */}
            </Switch>
          </ConditionalReCaptchaProvider>
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;
